import { Header } from '@amzn/awsui-components-react';
import React from 'react';
import { ExclusivityType, GandalfUser } from '../types/auth';
import { useIntl } from 'react-intl';
import styles from './CardContainer.module.css';
import SignInFailed from './SignInFailed';
import providersService from '../services/providers';
import { AppConfig } from '../types/app';
import accountlinkConsent from '../i18n/accountlinkConsent.messages';

const MultipleProfileLinkHeader = ({
  user,
  config,
}: {
  user: GandalfUser;
  config: AppConfig;
}): JSX.Element => {
  const { formatMessage } = useIntl();
  const provider = providersService.transformNameToIdProvider(
    user.providerName,
    config.gandalfDomain
  );
  if (user.associate_to) {
    return (
      <Header className={styles.header} variant="h2" headingTagOverride="h1">
        {user.associate_to.Exclusivity === ExclusivityType.INCLUSIVE
          ? formatMessage(accountlinkConsent.multipleLwaHeaderStepOneHeader)
          : formatMessage(accountlinkConsent.multipleExclusiveHeader)}
      </Header>
    );
  } else {
    return (
      <SignInFailed error={new Error('SignIn Failed')} provider={provider} />
    );
  }
};

export default MultipleProfileLinkHeader;
